module.exports = __webpack_public_path__ + "static/media/prop.6ed056dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/retained/prop.png
// module id = 71
// module chunks = 0